import getParameterForType from './getParameterForType';
import IParameter, { IParameterProperty } from '../../../../../../types/IParameter';
import { InputType } from '../../../InputTypes';

/**
 * Since the params from backend are stored in an array
 * this function converts them into a better accessable
 * object, turns them into their own respective model
 * and subscribes to them.
 *
 * @param params array from backends JSON
 * @param callback fn wich gets subscribed to the input put, param, whatever.
 */
const processParameters = <T extends IParameter>(
  params: IParameterProperty[] | undefined,
  callback: () => void,
): Record<string, T> => {
  const inputs = {} as Record<string, any>;
  if (params && params.length !== 0) {
    params.forEach((param) => {
      if (!inputs[param.name]) {
        inputs[param.name] = getParameterForType(param, params);
        inputs[param.name].subscribe(callback);
      } else if (param.type !== InputType.RADIO) {
        const input = getParameterForType(param, params);
        input.subscribe(callback);

        if (Array.isArray(inputs[param.name])) {
          inputs[param.name].push(input);
        } else {
          inputs[param.name] = [inputs[param.name], input];
        }
      }
    });
  }

  return inputs;
};

export default processParameters;
